import {useFeatureFlags} from "../../providers/FeatureFlagProvider/FeatureFlagProvider";

export const useIsVibrationsTabEnabled = () : boolean =>{
    const featureFlags = useFeatureFlags();
    return featureFlags.includes("isVibrationsTabEnabled");
}